import React, { FC, useEffect, useState } from "react";

import SectionHeader from "components/common/Ui/SectionHeader/SectionHeader";
import { TGetCurrentUserOrdersParams } from "core/models/order.model";
import { useGetCurrentUserOrders } from "core/services/api/order.api";
import { ListTable } from "components/common/ListTable/ListTable";
import { columns } from "./Columns";

const OrdersList: FC = () => {
  const [filterState, setFilterState] = useState<TGetCurrentUserOrdersParams>({
    page: 1,
    pageSize: 10,
  });

  const [tableData, setTableData] = useState<any>([]);
  const [initialPage, setInitialPage] = useState<number>(0);
  const [pageCountList, setPageCount] = useState<number>(0);

  const { data, isSuccess, isFetching } = useGetCurrentUserOrders(filterState);

  useEffect(() => {
    if (isSuccess && data?.data?.result) {
      const result = data?.data?.result;
      setTableData(result?.items);
      setPageCount(Math.ceil(result.totalCount / filterState.pageSize));
    }
  }, [data, isSuccess]);

  return (
    <>
      <SectionHeader title="سفارشات من" className="mb-5" />

      <ListTable
        columns={columns}
        isLoading={isFetching}
        onPageChange={({ page, pageSize }) => {
          setFilterState({
            page,
            pageSize,
          });
        }}
        tableData={tableData}
        pageCountList={pageCountList}
        customPageSize={filterState.pageSize}
        setPageSize={(val: any) => {
          setFilterState((prev: any) => ({ ...prev, pageSize: val }));
        }}
        initialPage={initialPage}
        setInitialPage={setInitialPage}
      />
    </>
  );
};

export { OrdersList };
